//====================================== DesktopVersion =====================================
// import seal_main from "../../Images/Main/DesktopVersion/seal_main.jpg";
// import sealion_main from "../../Images/Main/DesktopVersion/sealion_main.jpg"
import destroyer_05_main from "../../Images/Main/DesktopVersion/destroyer_05_main.jpg"
import dolphin_main from "../../Images/Main/DesktopVersion/dolphin_main.jpg"
import sea_lion_05_dmi_main from "../../Images/Main/DesktopVersion/sea_lion_05_dmi_main.jpg"
import seal_06_mdi_main from "../../Images/Main/DesktopVersion/seal_06_mdi_main.jpg"
import song_plus_dmi_main from "../../Images/Main/DesktopVersion/song_plus_dmi_main.jpg"
import song_pro_main from "../../Images/Main/DesktopVersion/song_pro_main.jpg"
import seagull_main from "../../Images/Main/DesktopVersion/seagull_main.jpg"

//====================================== MobileVersion ======================================
// import seal_main_mob from "../../Images/Main/MobileVersion/seal_main_mob.jpg";
// import sealion_main_mob from "../../Images/Main/MobileVersion/sealion_main_mob.jpg"
import destroyer_05_main_mob from "../../Images/Main/MobileVersion/destroyer_05_main_mob.jpg"
import dolphin_main_mob from "../../Images/Main/MobileVersion/dolphin_main_mob.png"
import sea_lion_05_dmi_main_mob from "../../Images/Main/MobileVersion/sea_lion_05_dmi_main_mob.jpg"
import seal_06_mdi_main_mob from "../../Images/Main/MobileVersion/seal_06_mdi_main_mob.jpg"
import song_plus_dmi_main_mob from "../../Images/Main/MobileVersion/song_plus_dmi_main_mob.jpg"
import song_pro_main_mob from "../../Images/Main/MobileVersion/song_pro_main_mob.jpg"
import seagull_main_mob from "../../Images/Main/MobileVersion/seagull_main_mob.jpg"

import contact_us from "../../Images/Main/contact_us.jpg";
import service from "../../Images/Service/pc11.jpg";

export const carModelsMain = [
  {
    id: 1,
    name: "SONG PLUS DM-i",
    img: song_plus_dmi_main,
    img_mob: song_plus_dmi_main_mob,
  },
  {
    id: 2,
    name: "DESTROYER 05",
    img: destroyer_05_main,
    img_mob: destroyer_05_main_mob,
  },
  {
    id: 3,
    name: "DOLPHIN",
    img: dolphin_main,
    img_mob: dolphin_main_mob,
  },
  {
    id: 4,
    name: "SEA LION 05 DM-i",
    img: sea_lion_05_dmi_main,
    img_mob: sea_lion_05_dmi_main_mob,
  },
  {
    id: 5,
    name: "SEAL 06 DM-i",
    img: seal_06_mdi_main,
    img_mob: seal_06_mdi_main_mob,
  },
  {
    id: 6,
    name: "SONG PRO",
    img: song_pro_main,
    img_mob: song_pro_main_mob,
  },
  {
    id: 7,
    name: "SEAGULL",
    img: seagull_main,
    img_mob: seagull_main_mob,
  },
  // {
  //   id: 1,
  //   name: "BYD SEAL",
  //   img: seal_main,
  //   img_mob: seal_main_mob,
  // },
  // {
  //   id: 2,
  //   name: "BYD SEALION 7",
  //   img: sealion_main,
  //   img_mob: sealion_main_mob,
  // },
];

export const testDriveAndContactUs = [
  {
    name: "service",
    path: "/Service",
    img: service,
  },
  {
    name: "contact_us",
    path: "/ContactUs",
    img: contact_us,
  },
];


